import { TYPE, GA as GA_CONST } from '@/constants';
import pickBy from 'lodash/pickBy';
import { GA } from './ga';

export default class RectangularGA extends GA {
  constructor(params) {
    super(params);
    this.initView();
  }

  get subtype() {
    return TYPE.GA_RECTANGULAR;
  }

  get width() {
    return this.attributes.width;
  }

  get height() {
    return this.attributes.height;
  }

  get radius() {
    return this.attributes.radius;
  }

  set cornerRadius(value) {
    this.setAttribute('radius', value);
    this.shape.radius(value);
  }

  initView() {
    const { width, height, position, radius, rotation } = this.attributes;
    const [cx, cy] = position;
    this.shape = this.canvas.rect(width, height).center(cx, cy);
    this.shape.radius(radius);
    const { cx: scx, cy: scy } = this.shapeRBox();
    this.attributes.shapecenter = [scx, scy];
    this.view.addClass(this.subtype);
    this.view.add(this.shape);
    this.view.transform({ rotation });
    this.recalculateEdgeOffsets();
    this.initLabel();
  }

  toJSON() {
    const { uuid, type, subtype, sid } = this;
    const { cx, cy } = this.rbox();
    const rotation = this.view.transform('rotation');
    const attributes = Object.assign({}, this.attributes, {
      position: [cx, cy],
      rotation,
    });
    const thisJson = RectangularGA.filteredJSON({
      uuid,
      sid,
      type,
      subtype,
      attributes,
    });
    if (thisJson.attributes.pos) {
      const newVal = pickBy(thisJson.attributes.pos, (p) => p);
      thisJson.attributes.pos = newVal;
    }
    return thisJson;
  }

  static fromJSON(params) {
    return RectangularGA.create(params);
  }

  static create(params) {
    const attributes = {
      label: Object.assign({}, GA_CONST.LABEL),
      position: [0, 0],
      rotation: 0,
      shapecenter: [],
      capacity: 100,
      width: 100,
      height: 100,
      radius: 0,
      styles: {},
    };
    params.attributes = Object.assign({}, attributes, params.attributes);
    return new RectangularGA(params);
  }
}
